import { RequestResponsePattern } from "../../types/Request"

export default function toResponsePattern<T>(data: T): RequestResponsePattern<T> {
    return {
        flagErro: false,
        listaMensagens: [] as string[],
        listaResultados: data as T
    }
}